import { defineComponent as _defineComponent } from 'vue'
import { onMounted, provide } from "vue";
import { Affiliate } from "@/services/affiliates/Affiliate";
import store from "@/store";
import { AFFILIATE_EDIT_KEY } from "./types";
import { useEditableFields } from "./useEditableFields";
import AboutCard from "./AboutCard.vue";
import CabinetSettingsCard from "./CabinetSettingsCard.vue";
import PayoutsCard from "./PayoutsCard.vue";
import AccountSettingsCard from "./AccountSettingsCard.vue";

interface Props {
    affiliate: Affiliate;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateMainInfo',
  props: {
    affiliate: null
  },
  emits: ['update-affiliate'],
  setup(__props: any) {

const props = __props as {
    affiliate: Affiliate;
}




const {
    editableFields,
    setCurrentValues,
    resetFields,
    editItem,
    getChangedValues,
    isFieldValid,
    isMessengerValid,
} = useEditableFields(() => props.affiliate);

provide(AFFILIATE_EDIT_KEY, {
    editableFields,
    editItem,
    isFieldValid,
    isMessengerValid,
    getChangedValues,
    resetFields,
});

onMounted(() => {
    setCurrentValues();
    store.commit('DELETE_AFFILIATE_VERIFIED_EMAILS', props.affiliate);
});

return { __sfc: true,props, editableFields, setCurrentValues, resetFields, editItem, getChangedValues, isFieldValid, isMessengerValid, AboutCard, CabinetSettingsCard, PayoutsCard, AccountSettingsCard }
}

})